import { motion } from 'framer-motion';

const steps = [
    {
        number: '01',
        title: 'We Chat',
        description: "A quick call to understand your spreadsheet situation. No sales pitch—just figuring out if I can help.",
    },
    {
        number: '02',
        title: 'I Build',
        description: "I create your automation, test it thoroughly, and make sure it actually works for your workflow.",
    },
    {
        number: '03',
        title: 'You Win',
        description: "I hand everything over with clear documentation. You save hours every week. Simple as that.",
    },
];

export const Process = () => {
    return (
        <section id="process" className="py-20 md:py-28 bg-white" data-testid="process-section">
            <div className="max-w-6xl mx-auto px-6 md:px-12">
                {/* Section Header */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="text-center mb-16"
                >
                    <p className="text-[#81B29A] text-sm font-medium uppercase tracking-widest mb-4">
                        How It Works
                    </p>
                    <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-4">
                        Three Simple Steps
                    </h2>
                    <p className="text-[#6B6B6B] text-lg max-w-2xl mx-auto">
                        No lengthy contracts or complicated onboarding. Let's just get your spreadsheets working better.
                    </p>
                </motion.div>

                {/* Steps */}
                <div className="grid md:grid-cols-3 gap-8">
                    {steps.map((step, index) => (
                        <motion.div
                            key={step.number}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.15 }}
                            className="relative text-center"
                            data-testid={`process-step-${index}`}
                        >
                            {/* Step number */}
                            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#F2E9E4] mb-6">
                                <span className="text-[#E07A5F] text-xl font-bold">{step.number}</span>
                            </div>
                            
                            <h3 className="font-serif text-xl font-semibold text-[#2C2C2C] mb-3">
                                {step.title}
                            </h3>
                            
                            <p className="text-[#6B6B6B] leading-relaxed">
                                {step.description}
                            </p>

                            {/* Connector line */}
                            {index < steps.length - 1 && (
                                <div className="hidden md:block absolute top-8 left-[60%] w-[80%] h-px bg-[#E6E1DB]" />
                            )}
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
